import React from "react";
import './Tabs.css'

type Tab = {
  label: React.ReactNode,
  value: string,
  selected: boolean
  onClick: () => void
}

type Props = {
  tabs: Tab[];
  children?: React.ReactNode;
  wrapperClass?: string;
}

const Tabs: React.FC<Props> = ({ tabs, children, wrapperClass }) => {
  return (
    <div className={wrapperClass}>
      <div className="tab-list">
        {tabs.map((tab) => (
          <div
            key={tab.value}
            className={`tab ${tab.selected ? 'selected' : ''}`}
            onClick={tab.onClick}>
            {tab.label}
          </div>
        ))}
      </div>
      {children}
    </div>
  )
}
export default Tabs
